export enum DocResources {
  Pdf = 1,
  Doc,
  Docx,
  Jpg,
  Jpeg,
  Png,
  Bmp,
  Gif,
  Xlsx,
  Wpd,
  Xls,
  Txt,
  Ppt,
  Pptx,
  Mov,
  Mp4,
  Mp3,
  Wmv,
  Avi
}
